// extracted by mini-css-extract-plugin
export default {"heading":"TopPageInfo_heading__FiiL2","avatar":"TopPageInfo_avatar__XuqoT","title":"TopPageInfo_title__yW7r+"};